import { useRef, useEffect } from 'react';

export function CookiebotDeclaration({ domainId }: { domainId: string }) {
  const target = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!domainId) return;

    if (!target.current?.hasChildNodes()) {
      const script = document.createElement('script');
      script.setAttribute('id', 'CookieDeclaration');
      script.setAttribute(
        'src',
        `https://consent.cookiebot.com/${domainId}/cd.js`
      );
      script.setAttribute('async', 'true');
      target.current?.appendChild(script);
    }
  }, [domainId]);

  return (
    <article>
      <header className="mt-16">
        <h1 className="hd-3xl text-center">Informasjonskapsler</h1>
      </header>

      <div ref={target} className="mt-8" />
    </article>
  );
}

export default CookiebotDeclaration;
